/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import Seccion_Home from "./Secciones/Seccion_Home";
import Seccion_Colecciones from "./Secciones/Seccion_Colecciones";
import Seccion_Detalle_Producto from "./Secciones/Seccion_Detalle_Producto";
import Seccion_Detalle_Coleccion from "./Secciones/Seccion_Detalle_Coleccion";
import Seccion_Detalle_Categoria from "./Secciones/Seccion_Detalle_Categoria";
import Seccion_Recibo from "./Secciones/Seccion_Recibo";
import '../Modulo_Cargador/cargador.css'
import Seccion_Todos_Productos from "./Secciones/Seccion_Todos_Productos";
import Seccion_Resultados from "./Secciones/Seccion_Resultados";
import Seccion_Nosotras from "./Secciones/Seccion_Nosotras";
import {useAnuncio} from "../Modulo_Anuncio/Hooks/useAnuncio";
import Anuncio_Suscribite from "./Anuncios/Anuncio_Suscribite";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../App";
import Seccion_Todos_Descuentos from "./Secciones/Seccion_Todos_Descuentos";

const Pagina = () => {
    const cData = useContext(contexApp)
    const {Anuncio} = useAnuncio({
        clave: 'suscripcion',
        Componente: Anuncio_Suscribite,
        retrazo: 5000,
        seccionesNoMostrar: 'Recibo',
        mostrar: cData.configuraciones.primera
    })


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Router>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 3}}>
                    <Barra/>
                </Grid>

                <Anuncio/>

                <Routes>
                    <Route path={"*"} element={<Seccion_Home/>}/>
                    <Route path={"/"} element={<Seccion_Home/>}/>
                    <Route path={"/Home"} element={<Seccion_Home/>}/>
                    <Route path={"/Colecciones"} element={<Seccion_Colecciones/>}/>
                    <Route path={"/Detalle/:id"} element={<Seccion_Detalle_Producto/>}/>
                    <Route path={"/DetalleCol/:id"} element={<Seccion_Detalle_Coleccion/>}/>
                    <Route path={"/DetalleCat/:id"} element={<Seccion_Detalle_Categoria/>}/>
                    <Route path={"/Recibo"} element={<Seccion_Recibo/>}/>
                    <Route path={"/Todos"} element={<Seccion_Todos_Productos/>}/>
                    <Route path={"/Resultados/:tipo/:id"} element={<Seccion_Resultados/>}/>
                    <Route path={"/Nosotras"} element={<Seccion_Nosotras/>}/>
                    <Route path={"/Descuentos"} element={<Seccion_Todos_Descuentos/>}/>
                </Routes>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                    <Footer/>
                </Grid>

            </Router>

        </Grid>
    )

}
export default Pagina